export default __webpack_public_path__ + "images/0xce1581d7b4ba40176f0e219b2cac30088ad50c7a.png";